import { throttle } from 'lodash';

class ResponsiveTableFactory
{
    static init(selector)
    {
        const responsiveTables = [];
        const tables = document.querySelectorAll(selector);
        if (tables.length)
        {

            Array.from(tables).forEach(table =>
            {
                responsiveTables.push(new ResponsiveTable(table));
            });
        }
        return responsiveTables;
    }
}
export default ResponsiveTableFactory;

export class ResponsiveTable
{
    constructor(table, params={})
    {
        params = {
            collapseClass: 'collapse',
            labelClass: 'collapsed-table-label',
            collapseWidth: 991,
            ...table.dataset,
            ...params
        }

        this.table = table;
        this.params = params;

        this.init();
    }

    init(table, params)
    {
        this.setWidths();
        this.setCellLabels();
        window.addEventListener('resize', throttle(e => this.handleResize(), 200));
        this.handleResize();
    }

        setWidths()
        {
            const firstRow = this.table.querySelector('tr');
            const rowWidth = firstRow.offsetWidth;
            Array.from(firstRow.children).forEach(cell =>
            {
                //const percentage = (cell.offsetWidth / rowWidth * 100);
                cell.style.width = (cell.offsetWidth / rowWidth * 100) + '%';
                //cell.style.width = null;
                //cell.setAttribute('width', percentage + '%');
            });

            this.table.setAttribute('width', '100%');
            this.table.style.height = null;
            this.table.style.width = null;
        }

        setCellLabels()
        {
            const ths = this.table.querySelectorAll('tr th');
            if (ths.length)
            {
                let nr = 1;
                Array.from(ths).forEach(th =>
                {
                    const nthCells = this.table.querySelectorAll(`tr td:nth-child(${nr})`)
                    if (nthCells.length)
                    {
                        Array.from(nthCells).forEach(cell =>
                        {
                            cell.insertAdjacentHTML('afterbegin', `<span class="${this.params.labelClass}">${th.textContent}</span>`);
                        })
                    }
                    nr++;
                });
            }
        }

    handleResize()
    {
        if (window.innerWidth <= this.params.collapseWidth)
        {
            this.table.classList.add(this.params.collapseClass);
        }
        else
        {
            this.table.classList.remove(this.params.collapseClass);
        }
    }

}
